"use client";

import { c as _c } from "react/compiler-runtime";
import { useRef } from "react";
import { useScroll } from "framer-motion";
import { SiteNavbar } from "@/shared/ui/site-navbar";
import { SiteFooter } from "@/shared/ui/site-footer";
import { HomeCtaSection } from "@/features/home/presentation/components/home-cta-section";
import type { HomePageContent } from "@/features/home/types/home-page-content";
import { AeroHero3 } from "@/shared/ui/aero-hero-3";
import { ServiceCard } from "../components/service-card";
import { SERVICES_DATA } from "../../constants/services-data";
interface ServicesListingPageProps {
  content: HomePageContent;
}
export function ServicesListingPage(t0) {
  const $ = _c(19);
  const {
    content
  } = t0;
  const containerRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      target: containerRef,
      offset: ["start start", "end end"]
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    scrollYProgress
  } = useScroll(t1);
  let t2;
  if ($[1] !== content.navigation) {
    t2 = <div className="absolute top-0 z-50 w-full"><SiteNavbar content={content.navigation} /></div>;
    $[1] = content.navigation;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <AeroHero3 backgroundImageUrl="https://res.cloudinary.com/dsalsyu0z/image/upload/v1779571214/CTA_kd1xfc.webp" eyebrow="Our Services" title="Healing tailored to you" description="Discover specialized therapeutic pathways designed to help you navigate life's challenges, repair relationships, and find profound emotional wellness." ctaLabel="Explore Services" ctaHref="#services" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== scrollYProgress) {
    t4 = SERVICES_DATA.map((service, idx) => <ServiceCard key={service.slug} service={service} index={idx} total={SERVICES_DATA.length} parentScrollProgress={scrollYProgress} />);
    $[4] = scrollYProgress;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <section id="services" ref={containerRef} className="relative bg-background">{t4}</section>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== content.ctaSection) {
    t6 = <div className="bg-background"><HomeCtaSection content={content.ctaSection} /></div>;
    $[8] = content.ctaSection;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== content.footer) {
    t7 = <div className="bg-[#0b1416]"><SiteFooter content={content.footer} /></div>;
    $[10] = content.footer;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6 || $[13] !== t7) {
    t8 = <div className="relative z-[55]">{t6}{t7}</div>;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t2 || $[16] !== t5 || $[17] !== t8) {
    t9 = <div className="relative min-h-screen bg-background font-sans selection:bg-accent/20 selection:text-foreground">{t2}{t3}{t5}{t8}</div>;
    $[15] = t2;
    $[16] = t5;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
}